import * as Yup from "yup";

export const createHPSchema = (t) => (Yup.object({
  name: Yup.string().required(t("hanging-protocol.error.blank", {field: t("hanging-protocol.name")})).min(3,t("hanging-protocol.error.min", {field: t("hanging-protocol.name"), min: "3"})).max(50, t("hanging-protocol.error.max", {field: t("hanging-protocol.name"), max: "50"})).matches(/^[a-zA-Z][a-zA-Z0-9\s\-_]*$/, t("hanging-protocol.error.invalid", {field: t("hanging-protocol.name")})),
  description: Yup.string().max(100, t("hanging-protocol.error.max", {field: t("hanging-protocol.description"), max: "100"})),
  studyPrerequisiteList: Yup.array()
    .of(
      Yup.object({
        tag: Yup.string()
          .required(t("hanging-protocol.error.blank", {field: t("hanging-protocol.tag")}))
          .min(1, t("hanging-protocol.error.min", {field: t("hanging-protocol.tag"), min: "1"})),
        operand: Yup.string()
          .required(t("hanging-protocol.error.blank", {field: t("hanging-protocol.operand")})),
         value: Yup.array()
            .of(
              Yup.string()
                .required(t("hanging-protocol.error.blank", { field: t("hanging-protocol.value") }))
                .min(1, t("hanging-protocol.error.min", { field: t("hanging-protocol.value"), min: "1" }))
            )
            .min(1, t("hanging-protocol.error.min-one-condition"))
            .required(t("hanging-protocol.error.blank", { field: t("hanging-protocol.value") })),
      })
    )
    .required(t("hanging-protocol.error.min-one-condition"))
    .min(1, t("hanging-protocol.error.min-one-condition")),
    layout: Yup.object({
      name: Yup.string().min(3,t("hanging-protocol.error.min", {field: t("hanging-protocol.name"), min: "3"})).max(50, t("hanging-protocol.error.max", {field: t("hanging-protocol.name"), max: "50"})).matches(/^[a-zA-Z][a-zA-Z0-9\s\-_]*$/, t("hanging-protocol.error.invalid", {field: t("hanging-protocol.name")})).required(t("hanging-protocol.error.blank", {field: t("hanging-protocol.name")})),
      rows: Yup.string().matches(/^[1-3]*$/, t("hanging-protocol.error.invalid", {field: t("hanging-protocol.rows")})),
      columns: Yup.string().matches(/^[1-3]*$/, t("hanging-protocol.error.invalid", {field: t("hanging-protocol.columns")})),
      viewportList: Yup.array()
        .of(
        Yup.object({
          windowWidth: Yup.string()
                    .nullable()
                    .test(
                      "valid-windowWidth",
                      t("hanging-protocol.error.invalid", { field: t("hanging-protocol.window-width") }),
                      value => {
                        if (value == null || value == "") return true; // allow empty
                        const num = Number(value);
                        return Number.isInteger(num) && num >= 1 && num <= 65535;
                      }
                    ),
          windowLevel: Yup.string()
                    .nullable()
                    .test(
                      "valid-windowLevel",
                      t("hanging-protocol.error.invalid", { field: t("hanging-protocol.window-level") }),
                      value => {
                        if (value == null || value == "") return true; // allow empty
                        const num = Number(value);
                        return Number.isInteger(num) && num >= -32768 && num <= 32767;
                      }
                    ),
          flipVertically: Yup.string().required(t("hanging-protocol.error.blank", {field: t("hanging-protocol.vertical-flip")})),
          flipHorizontally: Yup.string().required(t("hanging-protocol.error.blank", {field: t("hanging-protocol.horizontal-flip")})),
          alignment: Yup.string().required(t("hanging-protocol.error.blank", {field: t("hanging-protocol.alignment")})),
          rotation: Yup.string()
                  // .required(t("hanging-protocol.error.blank", { field: t("hanging-protocol.rotation") }))
                  .nullable()
                  .test(
                    "is-valid-rotation",
                    t("hanging-protocol.error.invalid", { field: t("hanging-protocol.rotation") }),
                    value => {
                      if (value === undefined || value === null || value === "") return true; // let 'required' handle blank
                      const num = Number(value);
                      return Number.isInteger(num) && num >= -360 && num <= 360;
                    }
                  ),
          seriesConditions: Yup.array()
            .of(
            Yup.object({
              tag: Yup.string()
                .required(t("hanging-protocol.error.blank", {field: t("hanging-protocol.tag")}))
                .min(1, t("hanging-protocol.error.min", {field: t("hanging-protocol.tag"), min: "1"})),
              operand: Yup.string()
                .required(t("hanging-protocol.error.blank", {field: t("hanging-protocol.operand")})),
              value: Yup.array()
                .of(Yup.string().trim().min(1))
                .min(1, t("hanging-protocol.error.blank", { field: t("hanging-protocol.value") }))
                .required(t("hanging-protocol.error.blank", { field: t("hanging-protocol.value") })),
            })
          )
          .required(t("hanging-protocol.error.min-one-condition"))
          .min(1, t("hanging-protocol.error.min-one-condition")),
          // imageConditions: Yup.array()
          // .of(
          //   Yup.object({
          //     tag: Yup.string()
          //       .required(t("hanging-protocol.error.blank", {field: t("hanging-protocol.tag")}))
          //       .min(1, t("hanging-protocol.error.min", {field: t("hanging-protocol.tag"), min: "1"})),
          //     operand: Yup.string()
          //       .required(t("hanging-protocol.error.blank", {field: t("hanging-protocol.operand")})),
          //     value: Yup.string()
          //       .required(t("hanging-protocol.error.blank", {field: t("hanging-protocol.value")})),
          //   })
          // )
          // .required(t("hanging-protocol.error.min-one-condition"))
          // .min(1, t("hanging-protocol.error.min-one-condition")),
      })
    )
    }),
      
}))
